export default __webpack_public_path__ + "static/media/AE14.b3c26ef7.jpg";